import React from "react";
import { Link } from "react-router-dom";

import { addCommas } from "@persian-tools/persian-tools";

import colorSchema from "../../assets/kits/colors";

import { DeliveryExpressIcon } from "../kits/Icons/Icons";
import Image from "./Image";

interface ShopSearchProps {
  title: string;
  deliveryCost: number;
  link: string;
}

const SupplierSearch: React.FC<ShopSearchProps> = ({
  title,
  deliveryCost,
  link,
}) => {
  return (
    <Link
      to={link}
      className="supplier-search-card d-flex justify-content-between pd-y-12 w-100"
      style={{ textDecoration: "none" }}
    >
      <p
        className="txt-t2-m"
        style={{ color: colorSchema.foreground_background_me }}
      >
        {title}
      </p>
      <div
        className="d-flex align-items-center pd-4"
        style={{ backgroundColor: colorSchema.schema_background_light }}
      >
        <DeliveryExpressIcon width={16} height={16} color="#000000" />
        <p
          className="desc-l mr-r-6"
          style={{ color: colorSchema.foreground_background_he }}
        >
          {deliveryCost == 0 ? "رایگان" : `${addCommas(deliveryCost)} تومان`}
        </p>
      </div>
    </Link>
  );
};

interface ProducrtSearchProps {
  title: string;
  supplierTitle: string;
  price: number;
  imageSrc: string;
  link: string;
}

const ProductSearch: React.FC<ProducrtSearchProps> = ({
  title,
  supplierTitle,
  price,
  imageSrc,
  link,
}) => {
  return (
    <Link
      to={link}
      className="product-search-card d-flex mr-x-0 pd-x-0 pd-y-12 w-100"
      style={{ textDecoration: "none" }}
    >
      <div
        className="mr-l-8"
        style={{ width: 48, height: 48, overflow: "hidden" }}
      >
        <Image
          width={48}
          height={48}
          style={{ borderRadius: 6 }}
          src={imageSrc}
          alt={`محصول ${title}`}
        />
      </div>
      <div className="d-flex flex-column justify-content-between w-100">
        <p
          className="txt-t2-r"
          style={{
            color: colorSchema.foreground_background_he,
            display: "-webkit-box",
            WebkitLineClamp: 1,
            width: "100%",
            textOverflow: "ellipsis",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            height: "21px",
          }}
        >
          {title}
        </p>
        <div className="d-flex justify-content-between">
          <p
            className="desc-l"
            style={{ color: colorSchema.foreground_background_me }}
          >
            {supplierTitle}
          </p>
          <p
            className="txt-t2-m"
            style={{ color: colorSchema.foreground_background_me }}
          >
            {addCommas(price)} تومان
          </p>
        </div>
      </div>
    </Link>
  );
};

export { SupplierSearch, ProductSearch };
